import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/share.png'
import _imports_2 from '@/assets/img/management/cameraIcon.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2db24185")

_pushScopeId("data-v-2db24185")
const _hoisted_1 = {
  key: 0,
  class: "fixedViewOverLayout paddingFromFixedShopFooter"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = { class: "tagsContainer" }
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_7 = { class: "genericPadding" }
const _hoisted_8 = { class: "fs_20 fw_700 spaceCadet mb-3" }
const _hoisted_9 = { class: "fs_12 greyBlue text-capitalize d-block mt-2 mb-2" }
const _hoisted_10 = { class: "d-flex flex-wrap" }
const _hoisted_11 = { class: "fs_12 d-block" }
const _hoisted_12 = {
  key: 0,
  class: "errorMessage fs_13 white d-block mt-5 text-center"
}
const _hoisted_13 = { class: "fixedShopFooter" }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_15 = { class: "amountNumber d-flex align-items-center justify-content-end" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "fs_16 spaceCadet" }, "-", -1)
const _hoisted_17 = { class: "fs_20 fw_700 spaceCadet mx-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "fs_16 spaceCadet" }, "+", -1)
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "fs_10 grey d-block ln_12" }
const _hoisted_21 = { class: "fs_20 fw_700 spaceCadet d-block" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_share_button = _resolveComponent("share-button")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "communityBgContainer",
          style: 'background-image: url(\'' + _ctx.model.thumbnailUrl + '\');'
        }, [
          _createVNode("div", {
            class: "absoluteButton topLeft",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
          }, [
            _hoisted_2
          ]),
          _createVNode(_component_share_button, {
            class: "absoluteButton topRight",
            shareUrl: _ctx.shareUrl
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["shareUrl"]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.model.category), 1)
          ]),
          _createVNode("div", {
            class: "absoluteButton bottomRight",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openGallery()))
          }, [
            _hoisted_6
          ])
        ], 4),
        _createVNode("div", _hoisted_7, [
          _createVNode("h2", _hoisted_8, _toDisplayString(_ctx.model.title), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.keys(_ctx.distinctVariations), (key, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "mt-2",
              key: index
            }, [
              _createVNode("label", _hoisted_9, _toDisplayString(key), 1),
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.distinctVariations[key], (variation, i) => {
                  return (_openBlock(), _createBlock("div", {
                    key: i,
                    class: ["filterTab", _ctx.selectedItem.variation.variations[key] == variation ? 'active' : ''],
                    onClick: ($event: any) => (_ctx.setVariation(key, variation))
                  }, [
                    _createVNode("span", _hoisted_11, _toDisplayString(variation), 1)
                  ], 10, ["onClick"]))
                }), 128))
              ])
            ]))
          }), 128)),
          _createVNode("span", {
            class: "fs_14 greyBlue d-block ln_12 mt-3 pre",
            innerHTML: _ctx.model.description
          }, null, 8, ["innerHTML"]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.minusAmount()))
                }, [
                  _hoisted_16
                ]),
                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.amountNumber), 1),
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.amountNumber++))
                }, [
                  _hoisted_18
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createVNode(_component_localized_text, {
                    localizedKey: 'app_pzdisponibili',
                    text: 'Pz. disponibili:'
                  }, null, 8, ["text"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedItem.availability), 1)
                ]),
                _createVNode("span", _hoisted_21, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.selectedItem.variation.price)), 1)
              ])
            ]),
            _createVNode("button", {
              class: "genericButton bgPurple squareGenericButton w-100",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addToCart()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_aggiungialcarrello",
                text: "Aggiungi al carrello",
                class: "fs_14 white text-uppercase"
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})